import { render, staticRenderFns } from "./ExternoPage.vue?vue&type=template&id=51345d9e"
import script from "./ExternoPage.js?vue&type=script&lang=js&external"
export * from "./ExternoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports